import React from "react";
import { Button } from "@/components/ui/button";
import { Sparkles, ShieldCheck, TrendingUp } from "lucide-react";

export default function Login() {
  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen w-full flex bg-navy-900 text-foreground overflow-hidden">
      {/* Left visual side */}
      <div className="hidden lg:flex flex-col justify-between w-1/2 p-14 relative"
           style={{ backgroundImage: "linear-gradient(180deg, rgba(2,6,23,0.85), rgba(2,6,23,0.95)), url('https://images.unsplash.com/photo-1611920629515-3f76f8c36b37?auto=format&fit=crop&w=1600&q=80')", backgroundSize: "cover", backgroundPosition: "center" }}>
        <div className="flex items-center gap-3">
          <div className="h-10 w-10 rounded-md gold-bg grid place-items-center font-heading text-lg font-semibold">Y</div>
          <div>
            <div className="font-heading text-xl tracking-tight">Youngness Centre</div>
            <div className="text-xs text-muted-foreground uppercase tracking-[0.25em]">by Dr. Awish</div>
          </div>
        </div>
        <div>
          <h1 className="text-5xl font-heading font-light leading-tight tracking-tight max-w-lg">
            The <span className="gold-text">clinical performance</span> command centre for our doctors.
          </h1>
          <p className="mt-6 text-muted-foreground max-w-md leading-relaxed">
            Live KPIs, tier-aware daily logs, projected incentives, and salary-revision milestones — everything each doctor and the founder needs, in one calm dashboard.
          </p>
          <div className="mt-10 grid grid-cols-3 gap-4 max-w-lg">
            {[
              { icon: <Sparkles className="h-4 w-4" />, k: "AI Insights", v: "Claude 5" },
              { icon: <TrendingUp className="h-4 w-4" />, k: "Incentive Auto-calc", v: "Slab-based" },
              { icon: <ShieldCheck className="h-4 w-4" />, k: "Private per doctor", v: "Row-level" },
            ].map((f, i) => (
              <div key={i} className="rounded-xl border border-navy-700 bg-navy-800/60 p-4 backdrop-blur-sm">
                <div className="gold-text">{f.icon}</div>
                <div className="mt-3 font-medium text-sm">{f.k}</div>
                <div className="text-xs text-muted-foreground">{f.v}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="text-xs text-muted-foreground">© {new Date().getFullYear()} Youngness Centre · Confidential</div>
      </div>

      {/* Right auth side */}
      <div className="flex-1 flex items-center justify-center p-8 subtle-grid">
        <div className="w-full max-w-md">
          <div className="lg:hidden mb-8 flex items-center gap-3">
            <div className="h-10 w-10 rounded-md gold-bg grid place-items-center font-heading text-lg font-semibold">Y</div>
            <div>
              <div className="font-heading text-lg">Youngness Centre</div>
              <div className="text-[10px] text-muted-foreground uppercase tracking-[0.25em]">by Dr. Awish</div>
            </div>
          </div>

          <div className="mb-8">
            <div className="text-xs uppercase tracking-[0.3em] text-muted-foreground">Sign in</div>
            <h2 className="mt-3 text-3xl font-heading font-medium">Welcome back.</h2>
            <p className="mt-2 text-sm text-muted-foreground">
              Sign in with your registered Google account. Doctors see only their own performance — the founder sees everything.
            </p>
            <div className="gold-underline mt-4" />
          </div>

          <Button
            data-testid="login-google-btn"
            onClick={handleGoogle}
            className="w-full h-12 rounded-md bg-white text-slate-900 hover:bg-slate-100 font-medium transition-colors duration-200"
          >
            <svg viewBox="0 0 24 24" className="h-5 w-5 mr-3">
              <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
              <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.25 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
              <path fill="#FBBC05" d="M5.84 14.1c-.22-.66-.35-1.36-.35-2.1s.13-1.44.35-2.1V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l3.66-2.83z"/>
              <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.83C6.71 7.31 9.14 5.38 12 5.38z"/>
            </svg>
            Continue with Google
          </Button>

          <p className="mt-6 text-xs text-muted-foreground text-center">
            By continuing, you agree to Youngness Centre's internal data & privacy policy. Session is valid for 7 days.
          </p>
        </div>
      </div>
    </div>
  );
}
